"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimInternalFields = exports.ClaimExternalFields = void 0;
var utils_1 = require("@hobt/utils");
var claim_fields_1 = require("./claim-fields");
exports.ClaimExternalFields = [
    claim_fields_1.ClaimFieldNames.claimID,
    claim_fields_1.ClaimFieldNames.approvedLenderCode,
    claim_fields_1.ClaimFieldNames.approvedLenderName,
    claim_fields_1.ClaimFieldNames.approvedLenderReferenceNumber,
    claim_fields_1.ClaimFieldNames.approvedLenderTransitNumber,
    claim_fields_1.ClaimFieldNames.claimTypeIndicator,
    claim_fields_1.ClaimFieldNames.cmhcLoanAccountNumber,
    claim_fields_1.ClaimFieldNames.correspondenceLanguage,
    claim_fields_1.ClaimFieldNames.externalClaimStatus,
    claim_fields_1.ClaimFieldNames.primaryBorrowerFirstName,
    claim_fields_1.ClaimFieldNames.primaryBorrowerLastName,
    claim_fields_1.ClaimFieldNames.recordCreatedTimestamp,
    claim_fields_1.ClaimFieldNames.recordCreatedUserFirstName,
    claim_fields_1.ClaimFieldNames.recordCreatedUserID,
    claim_fields_1.ClaimFieldNames.recordCreatedUserLastName,
    claim_fields_1.ClaimFieldNames.recordUpdatedTimestamp,
    claim_fields_1.ClaimFieldNames.recordUpdatedUserFirstName,
    claim_fields_1.ClaimFieldNames.recordUpdatedUserID,
    claim_fields_1.ClaimFieldNames.recordUpdatedUserLastName,
    claim_fields_1.ClaimFieldNames.typeOfClaim,
];
exports.ClaimInternalFields = [
    claim_fields_1.ClaimFieldNames.claimID,
    claim_fields_1.ClaimFieldNames.approvedLenderCode,
    claim_fields_1.ClaimFieldNames.approvedLenderName,
    claim_fields_1.ClaimFieldNames.approvedLenderReferenceNumber,
    claim_fields_1.ClaimFieldNames.approvedLenderTransitNumber,
    claim_fields_1.ClaimFieldNames.claimTypeIndicator,
    claim_fields_1.ClaimFieldNames.cmhcLoanAccountNumber,
    claim_fields_1.ClaimFieldNames.correspondenceLanguage,
    claim_fields_1.ClaimFieldNames.internalClaimStatus,
    claim_fields_1.ClaimFieldNames.primaryBorrowerFirstName,
    claim_fields_1.ClaimFieldNames.primaryBorrowerLastName,
    claim_fields_1.ClaimFieldNames.recordCreatedTimestamp,
    claim_fields_1.ClaimFieldNames.recordCreatedUserID,
    claim_fields_1.ClaimFieldNames.recordUpdatedTimestamp,
    claim_fields_1.ClaimFieldNames.recordUpdatedUserFirstName,
    claim_fields_1.ClaimFieldNames.recordUpdatedUserID,
    claim_fields_1.ClaimFieldNames.recordUpdatedUserLastName,
    claim_fields_1.ClaimFieldNames.typeOfClaim,
];
var ClaimInternalFieldsKey = utils_1.reduce(exports.ClaimInternalFields);
var ClaimExternalFieldsKey = utils_1.reduce(exports.ClaimExternalFields);
